import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-131e5bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-6 px-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Внимание!", -1))
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "bg-white p-6 mt-4",
  style: {"border-radius":"10px"}
}
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col gap-2 items-center justify-center text-sm"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении данных произошла ошибка", -1))
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-blue-400 text-sm font-semibold uppercase" }, " Список накладных ", -1))
const _hoisted_10 = { class: "flex items-center gap-4" }
const _hoisted_11 = { class: "flex items-center gap-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel mr-2" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "flex items-center justify-end gap-4 text-sm"
}
const _hoisted_15 = { class: "font-medium" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-bill mr-2" }, null, -1))
const _hoisted_17 = { class: "flex items-center justify-end my-6" }
const _hoisted_18 = { class: "max-w-full overflow-hidden overflow-x-auto pb-4" }
const _hoisted_19 = { class: "flex items-center justify-end mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cash_filters = _resolveComponent("cash-filters")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_cash_payment_method = _resolveComponent("cash-payment-method")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.accept_modal_state.is_opened)
      ? (_openBlock(), _createBlock(_component_the_modal, {
          key: 0,
          class: "medium",
          title: "Прием наличных",
          loading: _ctx.accept_modal_state.is_loading,
          onCancel: _ctx.onAcceptCancel,
          onConfirm: _ctx.onAcceptCash
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("p", null, [
              _createTextVNode(" Вы принимаете оплату наличными на сумму "),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatPriceToKZT(_ctx.acceptingItemsCashSum)), 1),
              _createTextVNode(". ")
            ]),
            (_ctx.isOperatorOneC)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Ответственность за сохранность денежных средств лежит на диспетчере до передачи в бухгалтерию. "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, { title: "Обработка наличных" }),
    _createVNode(_component_cash_filters, {
      class: "mt-9",
      loading: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersSubmit
    }, null, 8, ["loading", "onSubmit"]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.state.is_loading || _ctx.state.is_failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createBlock(_component_loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_7,
                    _createVNode(_component_new_button, { onClick: _ctx.loadCashPaymentStatuses }, {
                      default: _withCtx(() => [
                        _createTextVNode("Обновить")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_new_button, {
                    type: "button",
                    class: "primary small",
                    loading: _ctx.export_excel_state.is_loading,
                    onClick: _ctx.onExportExcel
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createTextVNode(" Экспортировать в Excel ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]),
                  _createVNode(_component_new_button, {
                    class: "NewButton--search",
                    loading: _ctx.state.is_loading,
                    disabled: _ctx.state.items.length === 0,
                    onClick: _ctx.tablesStore.toggleModal
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"])
                ]),
                (_ctx.state.selectedInvoicesIds.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("span", null, [
                        _createTextVNode("Выбрано: " + _toDisplayString(_ctx.state.selectedInvoicesIds.length) + ", на сумму ", 1),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatPriceToKZT(_ctx.selectedItemsCashSum)), 1)
                      ]),
                      (_ctx.isMultipleAcceptButtonShowed)
                        ? (_openBlock(), _createBlock(_component_new_button, {
                            key: 0,
                            disabled: !_ctx.canAcceptCash,
                            class: "primary",
                            onClick: _ctx.onAcceptMultipleItems
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16,
                              _createTextVNode(" Принять несколько ")
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_new_limit, {
                disabled: _ctx.state.is_loading || _ctx.state.is_failed,
                value: _ctx.state.limit,
                "total-items": _ctx.state.total_items,
                onChange: _ctx.onLimitChange
              }, null, 8, ["disabled", "value", "total-items", "onChange"]),
              _createVNode(_component_new_pagination, {
                class: "ml-6",
                disabled: _ctx.state.is_loading || _ctx.state.is_failed,
                "current-page": _ctx.state.current_page,
                "total-pages": _ctx.state.total_pages,
                onChangePage: _ctx.onChangePage
              }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_new_table, {
                "has-checkbox-column": "",
                "select-row-by": "invoiceId",
                columns: _ctx.TABLE_COLUMNS,
                rows: _ctx.state.items,
                "selected-rows": _ctx.state.selectedInvoicesIds,
                onSelectAll: _ctx.selectAllItems,
                onUnselectAll: _ctx.unselectAllItems
              }, {
                "td-checkbox": _withCtx(({ value, row }) => [
                  (_ctx.isSingleAcceptButtonShow(row))
                    ? (_openBlock(), _createBlock(_component_new_checkbox, {
                        key: 0,
                        disabled: !_ctx.canAcceptCash,
                        class: "checkbox--blue",
                        value: value,
                        onChange: ($event: any) => (_ctx.onSelectRow(row))
                      }, null, 8, ["disabled", "value", "onChange"]))
                    : _createCommentVNode("", true)
                ]),
                td: _withCtx(({ column, row }) => [
                  (column.key === 'invoiceNumber')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/invoice/${row.invoiceId}`,
                        target: "_blank",
                        class: "text-blue-500"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (column.key === 'invoiceStatus')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (row.invoiceStatus)
                            ? (_openBlock(), _createBlock(_component_cheap, {
                                key: 0,
                                class: _normalizeClass(["small font-bold", _ctx.getCheapClass(row.invoiceStatus.id)])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.invoiceStatus.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (column.key === 'orderCreatedDate')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.orderCreatedDate)), 1)
                          ], 64))
                        : (column.key === 'deliveredDate')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.deliveredDate)), 1)
                            ], 64))
                          : (column.key === 'deliveryCreatedDate')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.deliveryCreatedDate)), 1)
                              ], 64))
                            : (column.key === 'paymentStatusDate')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                  _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.paymentStatus.statusDate)), 1)
                                ], 64))
                              : (column.key === 'paymentMethod')
                                ? (_openBlock(), _createBlock(_component_cash_payment_method, {
                                    key: 6,
                                    "payment-method": row.paymentMethod
                                  }, null, 8, ["payment-method"]))
                                : (column.key === 'cashSum' || column.key === 'codPayment')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatPriceToKZT(row[column.key])), 1)
                                    ], 64))
                                  : (column.key === 'paymentStatus')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 8,
                                        class: _normalizeClass(["cash-payment-status", {
                                        'status--red': row[column.key].id === 4,
                                        'status--green':
                                            row[column.key].id === 5 || row[column.key].id === 3,
                                        'status--yellow': row[column.key].id === 1,
                                        'status--purple': row[column.key].id === 2,
                                    }])
                                      }, _toDisplayString(row[column.key].statusName), 3))
                                    : (column.key === 'paymentStatusWho')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                          (row.paymentStatus && row.paymentStatus.user)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(row.paymentStatus.user.name), 1)
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode("-")
                                              ], 64))
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                                        ], 64))
                ]),
                actions: _withCtx(({ row }) => [
                  (_ctx.isSingleAcceptButtonShow(row))
                    ? (_openBlock(), _createBlock(_component_new_button, {
                        key: 0,
                        disabled: !_ctx.canAcceptCash,
                        class: "primary extra-small",
                        onClick: ($event: any) => (_ctx.onAcceptSingleItem(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Принять ")
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "rows", "selected-rows", "onSelectAll", "onUnselectAll"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_new_limit, {
                disabled: _ctx.state.is_loading || _ctx.state.is_failed,
                value: _ctx.state.limit,
                "total-items": _ctx.state.total_items,
                onChange: _ctx.onLimitChange
              }, null, 8, ["disabled", "value", "total-items", "onChange"]),
              _createVNode(_component_new_pagination, {
                class: "ml-6",
                disabled: _ctx.state.is_loading || _ctx.state.is_failed,
                "current-page": _ctx.state.current_page,
                "total-pages": _ctx.state.total_pages,
                onChangePage: _ctx.onChangePage
              }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
            ])
          ], 64))
    ])
  ]))
}